package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets10 {
  internal val _28_mishley_16_txt: AssetResource by lazy { init__28_mishley_16_txt() }

  internal val _28_mishley_17_txt: AssetResource by lazy { init__28_mishley_17_txt() }

  internal val _28_mishley_18_txt: AssetResource by lazy { init__28_mishley_18_txt() }

  internal val _28_mishley_19_txt: AssetResource by lazy { init__28_mishley_19_txt() }

  internal val _28_mishley_20_txt: AssetResource by lazy { init__28_mishley_20_txt() }

  internal val _28_mishley_21_txt: AssetResource by lazy { init__28_mishley_21_txt() }

  internal val _28_mishley_22_txt: AssetResource by lazy { init__28_mishley_22_txt() }

  internal val _28_mishley_23_txt: AssetResource by lazy { init__28_mishley_23_txt() }

  internal val _28_mishley_24_txt: AssetResource by lazy { init__28_mishley_24_txt() }

  internal val _28_mishley_25_txt: AssetResource by lazy { init__28_mishley_25_txt() }

  internal val _28_mishley_26_txt: AssetResource by lazy { init__28_mishley_26_txt() }

  internal val _28_mishley_27_txt: AssetResource by lazy { init__28_mishley_27_txt() }

  internal val _28_mishley_28_txt: AssetResource by lazy { init__28_mishley_28_txt() }

  internal val _28_mishley_29_txt: AssetResource by lazy { init__28_mishley_29_txt() }

  internal val _28_mishley_30_txt: AssetResource by lazy { init__28_mishley_30_txt() }

  internal val _28_mishley_31_txt: AssetResource by lazy { init__28_mishley_31_txt() }

  internal val _29_iyov_01_txt: AssetResource by lazy { init__29_iyov_01_txt() }

  internal val _29_iyov_02_txt: AssetResource by lazy { init__29_iyov_02_txt() }

  internal val _29_iyov_03_txt: AssetResource by lazy { init__29_iyov_03_txt() }

  internal val _29_iyov_04_txt: AssetResource by lazy { init__29_iyov_04_txt() }

  internal val _29_iyov_05_txt: AssetResource by lazy { init__29_iyov_05_txt() }

  internal val _29_iyov_06_txt: AssetResource by lazy { init__29_iyov_06_txt() }

  internal val _29_iyov_07_txt: AssetResource by lazy { init__29_iyov_07_txt() }

  internal val _29_iyov_08_txt: AssetResource by lazy { init__29_iyov_08_txt() }

  internal val _29_iyov_09_txt: AssetResource by lazy { init__29_iyov_09_txt() }

  internal val _29_iyov_10_txt: AssetResource by lazy { init__29_iyov_10_txt() }

  internal val _29_iyov_11_txt: AssetResource by lazy { init__29_iyov_11_txt() }

  internal val _29_iyov_12_txt: AssetResource by lazy { init__29_iyov_12_txt() }

  internal val _29_iyov_13_txt: AssetResource by lazy { init__29_iyov_13_txt() }

  internal val _29_iyov_14_txt: AssetResource by lazy { init__29_iyov_14_txt() }

  internal val _29_iyov_15_txt: AssetResource by lazy { init__29_iyov_15_txt() }

  internal val _29_iyov_16_txt: AssetResource by lazy { init__29_iyov_16_txt() }

  internal val _29_iyov_17_txt: AssetResource by lazy { init__29_iyov_17_txt() }

  internal val _29_iyov_18_txt: AssetResource by lazy { init__29_iyov_18_txt() }

  internal val _29_iyov_19_txt: AssetResource by lazy { init__29_iyov_19_txt() }

  internal val _29_iyov_20_txt: AssetResource by lazy { init__29_iyov_20_txt() }

  internal val _29_iyov_21_txt: AssetResource by lazy { init__29_iyov_21_txt() }

  internal val _29_iyov_22_txt: AssetResource by lazy { init__29_iyov_22_txt() }

  internal val _29_iyov_23_txt: AssetResource by lazy { init__29_iyov_23_txt() }

  internal val _29_iyov_24_txt: AssetResource by lazy { init__29_iyov_24_txt() }

  internal val _29_iyov_25_txt: AssetResource by lazy { init__29_iyov_25_txt() }

  internal val _29_iyov_26_txt: AssetResource by lazy { init__29_iyov_26_txt() }

  internal val _29_iyov_27_txt: AssetResource by lazy { init__29_iyov_27_txt() }

  internal val _29_iyov_28_txt: AssetResource by lazy { init__29_iyov_28_txt() }

  internal val _29_iyov_29_txt: AssetResource by lazy { init__29_iyov_29_txt() }

  internal val _29_iyov_30_txt: AssetResource by lazy { init__29_iyov_30_txt() }

  internal val _29_iyov_31_txt: AssetResource by lazy { init__29_iyov_31_txt() }

  internal val _29_iyov_32_txt: AssetResource by lazy { init__29_iyov_32_txt() }

  internal val _29_iyov_33_txt: AssetResource by lazy { init__29_iyov_33_txt() }

  internal val _29_iyov_34_txt: AssetResource by lazy { init__29_iyov_34_txt() }

  internal fun values(): List<AssetResource> = listOf(_28_mishley_16_txt, _28_mishley_17_txt,
      _28_mishley_18_txt, _28_mishley_19_txt, _28_mishley_20_txt, _28_mishley_21_txt,
      _28_mishley_22_txt, _28_mishley_23_txt, _28_mishley_24_txt, _28_mishley_25_txt,
      _28_mishley_26_txt, _28_mishley_27_txt, _28_mishley_28_txt, _28_mishley_29_txt,
      _28_mishley_30_txt, _28_mishley_31_txt, _29_iyov_01_txt, _29_iyov_02_txt, _29_iyov_03_txt,
      _29_iyov_04_txt, _29_iyov_05_txt, _29_iyov_06_txt, _29_iyov_07_txt, _29_iyov_08_txt,
      _29_iyov_09_txt, _29_iyov_10_txt, _29_iyov_11_txt, _29_iyov_12_txt, _29_iyov_13_txt,
      _29_iyov_14_txt, _29_iyov_15_txt, _29_iyov_16_txt, _29_iyov_17_txt, _29_iyov_18_txt,
      _29_iyov_19_txt, _29_iyov_20_txt, _29_iyov_21_txt, _29_iyov_22_txt, _29_iyov_23_txt,
      _29_iyov_24_txt, _29_iyov_25_txt, _29_iyov_26_txt, _29_iyov_27_txt, _29_iyov_28_txt,
      _29_iyov_29_txt, _29_iyov_30_txt, _29_iyov_31_txt, _29_iyov_32_txt, _29_iyov_33_txt,
      _29_iyov_34_txt)
}

private fun init__28_mishley_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-16.txt\")") as String, rawPath =
    "allChapters/_28_mishley-16.txt")

private fun init__28_mishley_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-17.txt\")") as String, rawPath =
    "allChapters/_28_mishley-17.txt")

private fun init__28_mishley_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-18.txt\")") as String, rawPath =
    "allChapters/_28_mishley-18.txt")

private fun init__28_mishley_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-19.txt\")") as String, rawPath =
    "allChapters/_28_mishley-19.txt")

private fun init__28_mishley_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-20.txt\")") as String, rawPath =
    "allChapters/_28_mishley-20.txt")

private fun init__28_mishley_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-21.txt\")") as String, rawPath =
    "allChapters/_28_mishley-21.txt")

private fun init__28_mishley_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-22.txt\")") as String, rawPath =
    "allChapters/_28_mishley-22.txt")

private fun init__28_mishley_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-23.txt\")") as String, rawPath =
    "allChapters/_28_mishley-23.txt")

private fun init__28_mishley_24_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-24.txt\")") as String, rawPath =
    "allChapters/_28_mishley-24.txt")

private fun init__28_mishley_25_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-25.txt\")") as String, rawPath =
    "allChapters/_28_mishley-25.txt")

private fun init__28_mishley_26_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-26.txt\")") as String, rawPath =
    "allChapters/_28_mishley-26.txt")

private fun init__28_mishley_27_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-27.txt\")") as String, rawPath =
    "allChapters/_28_mishley-27.txt")

private fun init__28_mishley_28_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-28.txt\")") as String, rawPath =
    "allChapters/_28_mishley-28.txt")

private fun init__28_mishley_29_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-29.txt\")") as String, rawPath =
    "allChapters/_28_mishley-29.txt")

private fun init__28_mishley_30_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-30.txt\")") as String, rawPath =
    "allChapters/_28_mishley-30.txt")

private fun init__28_mishley_31_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-31.txt\")") as String, rawPath =
    "allChapters/_28_mishley-31.txt")

private fun init__29_iyov_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-01.txt\")") as String, rawPath =
    "allChapters/_29_iyov-01.txt")

private fun init__29_iyov_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-02.txt\")") as String, rawPath =
    "allChapters/_29_iyov-02.txt")

private fun init__29_iyov_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-03.txt\")") as String, rawPath =
    "allChapters/_29_iyov-03.txt")

private fun init__29_iyov_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-04.txt\")") as String, rawPath =
    "allChapters/_29_iyov-04.txt")

private fun init__29_iyov_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-05.txt\")") as String, rawPath =
    "allChapters/_29_iyov-05.txt")

private fun init__29_iyov_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-06.txt\")") as String, rawPath =
    "allChapters/_29_iyov-06.txt")

private fun init__29_iyov_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-07.txt\")") as String, rawPath =
    "allChapters/_29_iyov-07.txt")

private fun init__29_iyov_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-08.txt\")") as String, rawPath =
    "allChapters/_29_iyov-08.txt")

private fun init__29_iyov_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-09.txt\")") as String, rawPath =
    "allChapters/_29_iyov-09.txt")

private fun init__29_iyov_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-10.txt\")") as String, rawPath =
    "allChapters/_29_iyov-10.txt")

private fun init__29_iyov_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-11.txt\")") as String, rawPath =
    "allChapters/_29_iyov-11.txt")

private fun init__29_iyov_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-12.txt\")") as String, rawPath =
    "allChapters/_29_iyov-12.txt")

private fun init__29_iyov_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-13.txt\")") as String, rawPath =
    "allChapters/_29_iyov-13.txt")

private fun init__29_iyov_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-14.txt\")") as String, rawPath =
    "allChapters/_29_iyov-14.txt")

private fun init__29_iyov_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-15.txt\")") as String, rawPath =
    "allChapters/_29_iyov-15.txt")

private fun init__29_iyov_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-16.txt\")") as String, rawPath =
    "allChapters/_29_iyov-16.txt")

private fun init__29_iyov_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-17.txt\")") as String, rawPath =
    "allChapters/_29_iyov-17.txt")

private fun init__29_iyov_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-18.txt\")") as String, rawPath =
    "allChapters/_29_iyov-18.txt")

private fun init__29_iyov_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-19.txt\")") as String, rawPath =
    "allChapters/_29_iyov-19.txt")

private fun init__29_iyov_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-20.txt\")") as String, rawPath =
    "allChapters/_29_iyov-20.txt")

private fun init__29_iyov_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-21.txt\")") as String, rawPath =
    "allChapters/_29_iyov-21.txt")

private fun init__29_iyov_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-22.txt\")") as String, rawPath =
    "allChapters/_29_iyov-22.txt")

private fun init__29_iyov_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-23.txt\")") as String, rawPath =
    "allChapters/_29_iyov-23.txt")

private fun init__29_iyov_24_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-24.txt\")") as String, rawPath =
    "allChapters/_29_iyov-24.txt")

private fun init__29_iyov_25_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-25.txt\")") as String, rawPath =
    "allChapters/_29_iyov-25.txt")

private fun init__29_iyov_26_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-26.txt\")") as String, rawPath =
    "allChapters/_29_iyov-26.txt")

private fun init__29_iyov_27_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-27.txt\")") as String, rawPath =
    "allChapters/_29_iyov-27.txt")

private fun init__29_iyov_28_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-28.txt\")") as String, rawPath =
    "allChapters/_29_iyov-28.txt")

private fun init__29_iyov_29_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-29.txt\")") as String, rawPath =
    "allChapters/_29_iyov-29.txt")

private fun init__29_iyov_30_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-30.txt\")") as String, rawPath =
    "allChapters/_29_iyov-30.txt")

private fun init__29_iyov_31_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-31.txt\")") as String, rawPath =
    "allChapters/_29_iyov-31.txt")

private fun init__29_iyov_32_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-32.txt\")") as String, rawPath =
    "allChapters/_29_iyov-32.txt")

private fun init__29_iyov_33_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-33.txt\")") as String, rawPath =
    "allChapters/_29_iyov-33.txt")

private fun init__29_iyov_34_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-34.txt\")") as String, rawPath =
    "allChapters/_29_iyov-34.txt")

public actual val SharedRes.assets.allChapters._28_mishley_16_txt: AssetResource
  get() = CommonMainAssets10._28_mishley_16_txt

public actual val SharedRes.assets.allChapters._28_mishley_17_txt: AssetResource
  get() = CommonMainAssets10._28_mishley_17_txt

public actual val SharedRes.assets.allChapters._28_mishley_18_txt: AssetResource
  get() = CommonMainAssets10._28_mishley_18_txt

public actual val SharedRes.assets.allChapters._28_mishley_19_txt: AssetResource
  get() = CommonMainAssets10._28_mishley_19_txt

public actual val SharedRes.assets.allChapters._28_mishley_20_txt: AssetResource
  get() = CommonMainAssets10._28_mishley_20_txt

public actual val SharedRes.assets.allChapters._28_mishley_21_txt: AssetResource
  get() = CommonMainAssets10._28_mishley_21_txt

public actual val SharedRes.assets.allChapters._28_mishley_22_txt: AssetResource
  get() = CommonMainAssets10._28_mishley_22_txt

public actual val SharedRes.assets.allChapters._28_mishley_23_txt: AssetResource
  get() = CommonMainAssets10._28_mishley_23_txt

public actual val SharedRes.assets.allChapters._28_mishley_24_txt: AssetResource
  get() = CommonMainAssets10._28_mishley_24_txt

public actual val SharedRes.assets.allChapters._28_mishley_25_txt: AssetResource
  get() = CommonMainAssets10._28_mishley_25_txt

public actual val SharedRes.assets.allChapters._28_mishley_26_txt: AssetResource
  get() = CommonMainAssets10._28_mishley_26_txt

public actual val SharedRes.assets.allChapters._28_mishley_27_txt: AssetResource
  get() = CommonMainAssets10._28_mishley_27_txt

public actual val SharedRes.assets.allChapters._28_mishley_28_txt: AssetResource
  get() = CommonMainAssets10._28_mishley_28_txt

public actual val SharedRes.assets.allChapters._28_mishley_29_txt: AssetResource
  get() = CommonMainAssets10._28_mishley_29_txt

public actual val SharedRes.assets.allChapters._28_mishley_30_txt: AssetResource
  get() = CommonMainAssets10._28_mishley_30_txt

public actual val SharedRes.assets.allChapters._28_mishley_31_txt: AssetResource
  get() = CommonMainAssets10._28_mishley_31_txt

public actual val SharedRes.assets.allChapters._29_iyov_01_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_01_txt

public actual val SharedRes.assets.allChapters._29_iyov_02_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_02_txt

public actual val SharedRes.assets.allChapters._29_iyov_03_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_03_txt

public actual val SharedRes.assets.allChapters._29_iyov_04_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_04_txt

public actual val SharedRes.assets.allChapters._29_iyov_05_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_05_txt

public actual val SharedRes.assets.allChapters._29_iyov_06_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_06_txt

public actual val SharedRes.assets.allChapters._29_iyov_07_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_07_txt

public actual val SharedRes.assets.allChapters._29_iyov_08_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_08_txt

public actual val SharedRes.assets.allChapters._29_iyov_09_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_09_txt

public actual val SharedRes.assets.allChapters._29_iyov_10_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_10_txt

public actual val SharedRes.assets.allChapters._29_iyov_11_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_11_txt

public actual val SharedRes.assets.allChapters._29_iyov_12_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_12_txt

public actual val SharedRes.assets.allChapters._29_iyov_13_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_13_txt

public actual val SharedRes.assets.allChapters._29_iyov_14_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_14_txt

public actual val SharedRes.assets.allChapters._29_iyov_15_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_15_txt

public actual val SharedRes.assets.allChapters._29_iyov_16_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_16_txt

public actual val SharedRes.assets.allChapters._29_iyov_17_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_17_txt

public actual val SharedRes.assets.allChapters._29_iyov_18_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_18_txt

public actual val SharedRes.assets.allChapters._29_iyov_19_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_19_txt

public actual val SharedRes.assets.allChapters._29_iyov_20_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_20_txt

public actual val SharedRes.assets.allChapters._29_iyov_21_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_21_txt

public actual val SharedRes.assets.allChapters._29_iyov_22_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_22_txt

public actual val SharedRes.assets.allChapters._29_iyov_23_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_23_txt

public actual val SharedRes.assets.allChapters._29_iyov_24_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_24_txt

public actual val SharedRes.assets.allChapters._29_iyov_25_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_25_txt

public actual val SharedRes.assets.allChapters._29_iyov_26_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_26_txt

public actual val SharedRes.assets.allChapters._29_iyov_27_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_27_txt

public actual val SharedRes.assets.allChapters._29_iyov_28_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_28_txt

public actual val SharedRes.assets.allChapters._29_iyov_29_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_29_txt

public actual val SharedRes.assets.allChapters._29_iyov_30_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_30_txt

public actual val SharedRes.assets.allChapters._29_iyov_31_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_31_txt

public actual val SharedRes.assets.allChapters._29_iyov_32_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_32_txt

public actual val SharedRes.assets.allChapters._29_iyov_33_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_33_txt

public actual val SharedRes.assets.allChapters._29_iyov_34_txt: AssetResource
  get() = CommonMainAssets10._29_iyov_34_txt
